<div class="labels" data-test="labelsElement" *ngIf="interactive">
  <!-- story labels -->
  <ng-container *ngIf="showAnatomyLabels">
    <!-- context label -->
    <app-context-label
      *ngIf="(enableContextLabel$ | async) && (contextLabel$ | async)"
      [label]="contextLabel$ | async"
      [enableInfo]="(enableContextLabelInfo$ | async) && (layout$ | async)?.nodeInfo.enable"
      [enableActions]="
        (enableContextLabelActions$ | async) && (layout$ | async)?.contextActions.enable
      ">
    </app-context-label>

    <!-- chapter labels -->
    <ng-container *ngFor="let label of labels$ | async; trackBy: trackLabel">
      <app-story-label
        data-test="appStoryLabel"
        class="labels__label"
        [class.labels__label--hidden]="!label.shown"
        [pinDraggable]="(draggable$ | async)?.pin"
        [tagDraggable]="(draggable$ | async)?.tag"
        [label]="label"
        [collapsed]="labelsCollapsed$ | async"
        [collapsedMode]="labelsCollapsedMode$ | async">
      </app-story-label>
    </ng-container>
  </ng-container>

  <!-- quiz labels -->
  <ng-container *ngIf="showQuizLabels">
    <app-quiz-labels></app-quiz-labels>
  </ng-container>
</div>
